'use client'

import { useEffect } from 'react'

export default function VhVar() {
  useEffect(() => {
    // const cli
    //https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
    const el = document.documentElement
    const minWidth = 320

    function onWindowResize() {
      const width = document.documentElement.clientWidth

      el.style.setProperty('--vh', window.innerHeight * 0.01 + 'px')
      el.style.setProperty('--dvh', window.innerHeight * 0.01 + 'px')
      el.style.setProperty('--vw', width * 0.01 + 'px')
      el.style.setProperty(
        '--svh',
        document.documentElement.clientHeight * 0.01 + 'px',
      )
      el.style.setProperty('--lvh', '1vh')

      el.style.setProperty('--min-width', '320px')
      el.style.setProperty('--container-full', '100%')

      if (width <= minWidth) {
        el.style.setProperty('--svh', window.innerHeight * 0.01 + 'px')
        el.style.setProperty('--container-full', width + 'px')
      }
    }

    window.addEventListener('resize', onWindowResize, false)
    onWindowResize()

    return () => {
      window.removeEventListener('resize', onWindowResize, false)
    }
  }, [])

  return null
}
